import React, { useState } from "react";
import Bg from "../../../images/shapes/shape_title_under_line.svg";
import shape1 from "../../../images/shapes/shape_space_4.svg";
import shape2 from "../../../images/shapes/shape_angle_3.webp";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

const FaqSection = (props) => {
  const [open, setOpen] = useState("1");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <section className="faq_section section_decoration">
      <div className="container">
        <div className="heading_block text-center">
          <div
            className="heading_focus_text has_underline d-inline-flex"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            F.A.Q.
          </div>
          <h2 className="heading_text mb-0">
            Need a <mark>Support?</mark>
          </h2>
        </div>

        <div className="faq_accordion accordion" id="faq_accordion">
          <Accordion
            open={open}
            toggle={toggle}
            className="accordion"
            id="service_process_faq"
          >
            <AccordionItem className="accordion-item">
              <AccordionHeader targetId="1">
                Q. What services does your software development company provide?
              </AccordionHeader>
              <AccordionBody accordionId="1" className="acc_body">
                <div className="text_a">A.</div>
                <p>
                  We offer a wide range of software development services
                  tailored to meet your business needs. These include but are
                  not limited to:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Custom software development
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Mobile and web app development
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          AI and machine learning solutions
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          E-commerce platform development
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Cloud application development
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          IT consulting and strategy
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Cybersecurity and data protection
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          API development and integration
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>

            <AccordionItem className="accordion-item">
              <AccordionHeader targetId="2">
                Q. How long does it take to develop custom software?
              </AccordionHeader>
              <AccordionBody accordionId="2" className="acc_body">
                <div className="text_a">B.</div>
                <p>
                  The timeline for developing custom software depends on
                  multiple factors such as project complexity, features
                  required, and client requirements. Generally, development can
                  take:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Complexity of Features
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Number of Platforms
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Third-Party Integrations
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Agile vs. Waterfall Approach
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Team Size & Expertise
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Testing & Debugging
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Client Feedback & Revisions
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Security & Compliance Requirements
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>

            <AccordionItem className="accordion-item">
              <AccordionHeader targetId="3">
                Q. What industries do you serve?
              </AccordionHeader>
              <AccordionBody accordionId="3" className="acc_body">
                <div className="text_a">C.</div>
                <p>
                  Our software development services cater to a wide range of
                  industries, including:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Insurance</span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Banking</span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Fintech</span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Logistic</span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Retail</span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">Healthcare</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>

            <AccordionItem className="accordion-item">
              <AccordionHeader targetId="4">
                Q. How do you ensure the security of our software?
              </AccordionHeader>
              <AccordionBody accordionId="4" className="acc_body">
                <div className="text_a">D.</div>
                <p>
                  We implement strict security protocols in every stage of
                  development, including:
                </p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          End-to-End Data Encryption
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Secure Authentication & Role-Based Access Control
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Regular Security Audits & Vulnerability Testing
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Compliance with Industry Standards (GDPR, HIPAA,
                          PCI-DSS)
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Secure API & Third-Party Integration Practices
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Real-Time Threat Monitoring & Incident Response
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Automated Backups & Disaster Recovery Plans
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Code Reviews & Secure Development Lifecycle (SDLC)
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>

            <AccordionItem className="accordion-item">
              <AccordionHeader targetId="5">
                Q. How do you support clients after the software is delivered?
              </AccordionHeader>
              <AccordionBody accordionId="5" className="acc_body">
                <div className="text_a">E.</div>
                <p>Our support doesn’t end after deployment. We offer:</p>
                <div className="row">
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Ongoing Maintenance & Bug Fixes
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Software Updates & Feature Enhancements
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          24/7 Technical Support & Help Desk
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Performance Monitoring & Optimization
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Security Patches & Compliance Updates
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          User Training & Documentation
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Cloud Hosting & Infrastructure Support
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Data Backup & Disaster Recovery
                        </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="icon_list unordered_list_block">
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Cloud application development
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          IT consulting and strategy
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          Cybersecurity and data protection
                        </span>
                      </li>
                      <li>
                        <span className="icon_list_icon">
                          <i className="fa-solid fa-circle fa-fw"></i>
                        </span>
                        <span className="icon_list_text">
                          API development and integration
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
      <div className="decoration_item shape_image_1">
        <img src={shape1} alt="Zarnix Shape" />
      </div>
      <div className="decoration_item shape_image_2">
        <img src={shape2} alt="Zarnix Shape Angle" />
      </div>
    </section>
  );
};
export default FaqSection;
